import React from 'react';
import { ScrollView, View, Appearance, RefreshControl, Platform } from 'react-native';
import axios from 'axios';
import { router } from 'expo-router';
import { MotiView } from 'moti';
import { Skeleton } from 'moti/skeleton';
import { InfoCircle } from 'iconsax-react-native';
import { FAB, Text, Button, Banner } from 'react-native-paper';
import RBSheet from "react-native-raw-bottom-sheet";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import ChartCard from '../../components/ChartCard/ChartCard';
import Spacer from '../../components/Spacer/Spacer';
import { MainContext } from '../../contexts/MainContext';

export default function Index() {
  const myContext = React.useContext(MainContext);
  const refRBSheet = React.useRef();
  const insets = useSafeAreaInsets();
  const [pageLoading, setPageLoading] = React.useState(true);
  const [isReflesh, setIsReflesh] = React.useState(false);
  const colorScheme = Appearance.getColorScheme();
  const [fabShowen, setFabShowen] = React.useState(true);
  const [dashboardData, setDashboardData] = React.useState(false);
  const [needUpdateVisible, setNeedUpdateVisible] = React.useState(false);
  const [checkTransferVisible, setCheckTransferVisible] = React.useState(false);

  React.useEffect(() => {
    getFirstData();
  }, [])

  const getFirstData = () => {
    setIsReflesh(true);
    setPageLoading(true);
    axios.all([
      axios.get(`/panel/dashboard`),
    ])
    .then(axios.spread((response) => {
      if(response.data.success) {
        setDashboardData(response.data.data);
        if(response.data.data.countNeedUpdateAd >= 10) {
          setNeedUpdateVisible(true);
        }
        if(response.data.data.referredAd >= 10) {
          setCheckTransferVisible(true);
        }
      }
    }))
    .catch(myContext.handleAxiosError)
    .finally(() => {setPageLoading(false); setIsReflesh(false)});
  }

  const isCloseToBottom = ({layoutMeasurement, contentOffset, contentSize}) => {
    const paddingToBottom = 300;
    return layoutMeasurement.height + contentOffset.y >=
      contentSize.height - paddingToBottom;
  };  

  if(pageLoading) {
    return (
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={{ flex: 1, justifyContent: 'space-between', paddingVertical: 16, paddingHorizontal: 18 }}
        animate={{ backgroundColor: colorScheme === 'dark' ? '#000000' : '#e6eaee' }}
      >
        <View>
          <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
          <Spacer height={20} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={100} />
          <Spacer height={16} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={100} />
          <Spacer height={16} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={100} />
          <Spacer height={16} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={100} />
        </View>
        <Spacer height={16} />
        <Skeleton colorMode={colorScheme} width={'100%'} height={100} />
      </MotiView>
    );
  } else {
    return (
      <>
        <ScrollView 
          contentContainerStyle={{ backgroundColor: '#e6eaee', paddingHorizontal: 18, paddingBottom: 8, direction: 'rtl' }}
          onScroll={({nativeEvent}) => {
            if (isCloseToBottom(nativeEvent)) {
              setFabShowen(false);
            } else {
              setFabShowen(true);
            }
          }}
          scrollEventThrottle={400}
          refreshControl = {
            <RefreshControl
              refreshing={isReflesh}
              onRefresh={() => getFirstData()}
            />
          }
        >
          <Banner
            visible={needUpdateVisible}
            style={{ marginBottom: 12, marginTop: needUpdateVisible ? 16 : -10 }}
            contentStyle={{ fontSize: 12, borderRadius: 8, borderWidth: 1, borderColor: '#FFA200', backgroundColor: '#FFF2DB', paddingTop: 0, marginTop: 0 }}
            elevation={0}
            icon={({size}) => (
              <InfoCircle size={size} color="#FFA200" variant="Bold"/>
            )}
          >
            {dashboardData.notCheckedUpdateAdText}
          </Banner>
          <Banner
            visible={checkTransferVisible}
            style={{ marginBottom: 12, marginTop: checkTransferVisible ? 0 : 0 }}
            contentStyle={{ fontSize: 12, borderRadius: 8, borderWidth: 1, borderColor: '#FFA200', backgroundColor: '#FFF2DB', paddingTop: 0, marginTop: 0 }}
            elevation={0}
            icon={({size}) => (
              <InfoCircle size={size} color="#FFA200" variant="Bold"/>
            )}
          >
            {dashboardData.notCheckedTransferAdText}
          </Banner>
          <ChartCard isBig title="همه آگهی‌ها" all={dashboardData.countAllAd} today={dashboardData.countTodayAd} color="#f00" page='allAds' />
          <ChartCard title="آگهی‌های من" all={dashboardData.countMyAd} today={dashboardData.countTodayMyAd} color="#2B93F3" page='myAds' />
          {myContext.role === 'super-admin' && <ChartCard title="آگهی‌های تایید نشده" all={dashboardData.countRegionAd} today={dashboardData.countTodayRegionAd} color="#3C9A4F" page='myRegion' />}
          <ChartCard title="آگهی‌های ارجاع شده" all={dashboardData.referredAd} today={dashboardData.todayReferredAd} color="#D61600" page='transferredAds' />
          <ChartCard title="آگهی‌های نیاز به بروزرسانی" all={dashboardData.countNeedUpdateAd} today={dashboardData.todayNeedUpdateAd} color="#FFA200" page='needUpdate' />
          <ChartCard title="آگهی‌های بایگانی" all={dashboardData.trashAd} today={dashboardData.todayTrashAd} color="#FFA200" page='archivedAds' />
          <ChartCard title="همه مشتری‌ها" all={dashboardData.allCus} today={dashboardData.todayAllCus} color="#2B93F3" page='allCustomer' />
          <ChartCard title="مشتری‌های من" all={dashboardData.myCus} today={dashboardData.todayMyCus} color="#2B93F3" page='myCustomer' />
          <ChartCard title="درخواست کارشناسی من" all={dashboardData.Inspections} today={dashboardData.TodayInspections} color="#D61600" page='inspection' />
          <ChartCard title="درخواست بازدید" all={dashboardData.propertyVisitCount} today={dashboardData.todayPropertyVisitCount} color="#3C9A4F" page='propertyVisit' />
          <ChartCard title="گزارش بازدید" all={dashboardData.visitReportCount} today={dashboardData.todayVisitReportCount} color="#3C9A4F" page='myVisitReport' />
          <RBSheet
            ref={refRBSheet}
            closeOnDragDown={true}
            closeOnPressMask={true}
            height={310}
            customStyles={{
              container: {
                paddingBottom: insets.bottom,
              },
              wrapper: {
                backgroundColor: "rgba(0, 0, 0, 0.3)"
              },
              draggableIcon: {
                backgroundColor: "#555"
              }
            }}
          >
            <ScrollView contentContainerStyle={{ flex: 1, alignItems: 'center', paddingHorizontal: 20 }}>
              <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', textAlign: 'center', marginTop: 10, marginBottom: 24 }}>برای ثبت ملک و ثبت مشتری و همچنین گزارش بازدید از طریق دکمه های زیر اقدام فرمایید</Text>
              <Button mode="contained" disabled={needUpdateVisible || checkTransferVisible} style={{ width: '100%', marginBottom: 8, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} labelStyle={{ fontFamily: 'IRANSans_Medium', fontSize: 16 }} onPress={() => {refRBSheet.current?.close(); router.push(`/adds`)} }>ثبت آگهی</Button>
              <Button mode="outlined" style={{ width: '100%', marginBottom: 8, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} labelStyle={{ fontFamily: 'IRANSans_Medium', fontSize: 16 }} onPress={() => {refRBSheet.current?.close(); router.push(`/customer`)}}>ثبت مشتری</Button>
              <Button mode="outlined" style={{ width: '100%', marginBottom: 8, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} labelStyle={{ fontFamily: 'IRANSans_Medium', fontSize: 16 }} onPress={() => {refRBSheet.current?.close(); router.push(`/visitReport`)}}>گزارش بازدید</Button>
            </ScrollView>
          </RBSheet>
        </ScrollView>
        <FAB
          icon="plus"
          style={{ backgroundColor: '#f9e013', position: 'absolute', margin: 20, right: Platform.OS === 'web' ? 'auto' : 0, left: Platform.OS === 'web' ? 0 : 'auto', bottom: 0 }}
          rippleColor="rgba(0, 0, 0, .1)"
          color="#fff"
          visible={fabShowen}
          onPress={() => refRBSheet.current.open()}
        />
      </>
    );
  }
}

